<template>
  <div class="sidebar-minimize-icon-container">
    <a-icon class="minimize-icon" @click="toggleIcon" :type="toggled ? 'right' : 'left'" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SidebarMinimizeButton',
  methods: {
    ...mapActions({
      'toggleSidebar': 'sidebar/toggleSidebar'
    }),
    toggleIcon: function (event) {
      this.toggleSidebar()
    }
  },
  computed: {
    ...mapState({
      toggled: state => state.sidebar.toggled
    })
  }
}
</script>

<style scoped lang="scss">
.sidebar-minimize-icon-container{
  text-align: right;
}
.minimize-icon{
  margin-right: 7px;
  cursor: pointer;
}
</style>
